/* eslint-disable */
import Auth from "@aws-amplify/auth";
import axios from "axios";
import { getData } from "../contexts/authContext";

const API_URL = process.env.REACT_APP_COGNITO_URL;
const instance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    Authorization: "",
  },
});

// const instance = axios.create({
//   baseURL: API_URL,
  
// });

instance.interceptors.request.use(async (config: any) => {
  const token = await getData("idToken");
  // if (token) {
  config.headers.Authorization = token;
  // }
  return config;
});

export const changeEmail = async (newEmail: string, email: string) => {
  const tokenAccess = await getData("accessToken");
  const token = await getData("idToken");
  return instance.post(
    "/change-email?email=" + email,
    { newEmail: newEmail, accessToken: tokenAccess },
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const confirmChangeEmail = async (
  code: string,
  newEmail: string,
  email: string
) => {
  const tokenAccess = await getData("accessToken");
  const token = await getData("idToken");
  const data = JSON.stringify({
    accessToken: tokenAccess,
    code: code,
    newEmail: email,
  });
  return instance.post("/change-email-confirm?email=" + newEmail, data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
};

export const changePhone = async (phone: string, email: string) => {
  const tokenAccess = await getData("accessToken");
  const token = await getData("idToken");
  const data = JSON.stringify({phone_number: phone, accessToken: tokenAccess})
  return instance.post(
    "/change-email?email=" + email,
    { phone_number: phone, accessToken: tokenAccess },
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const confirmChangePhone = async (
  code: string,
  phone: string,
  email: string
) => {
  const tokenAccess = await getData("accessToken");
  const token = await getData("idToken");
  const data = JSON.stringify({
    accessToken: tokenAccess,
    code: code,
    phone_number: phone,
  });
  return instance.post("/change-email-confirm?email=" + email, data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
};


export const adminInviteUser = async (email: string) => {
  const tokenAccess = await getData("accessToken");
  const token = await getData("idToken");
  return instance.post(
    "/invite-user",
    { email: email },
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const adminAddUserToGroup = async (email: string, groupName: string) => {
  const tokenAccess = await getData("accessToken");
  const token = await getData("idToken");
  return instance.post(
    "/add-user-to-group",
    { email: email, groupName: groupName },
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
};

/*
export const adminDeleteUserGroups = async (email: string) => {
  const tokenAccess = await getData("accessToken");
  const token = await getData("idToken");
  const userGroupList = await adminListGroupsForUser(email);
  if(userGroupList && userGroupList?.data && userGroupList?.data?.Groups){
    userGroupList?.data?.Groups?.forEach((group : any) => {
        instance.post(
          "/remove-user-from-group",
          { email: email, groupName: group.GroupName },
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );
    });
  }
};


export const adminDeleteUser = async (email: string) => {
  const tokenAccess = await getData("accessToken");
  const token = await getData("idToken");
  return instance.post(
    "/delete-user",
    { email: email },
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const adminDisableUser = async (email: string) => {
  const tokenAccess = await getData("accessToken");
  const token = await getData("idToken");
  return instance.post(
    "/disable-user",
    { email: email },
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
};
*/
export const adminListGroupsForUser = async (email: string) => {
  const tokenAccess = await getData("accessToken");
  const token = await getData("idToken");
  return instance.post(
    "/list-user-groups",
    { email: email },
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
};
